import ContactActions from 'bukku/redux/Contact/actions';
import TransactionActions from 'bukku/redux/Transaction/actions';
import { put, select } from 'redux-saga/effects';
import { LightboxType } from '../options';
import fileManagerChangeIndex from './fileManager';

const {
    setFiles: setTransactionFiles,
} = TransactionActions;
const {
    setFiles: setContactFiles,
} = ContactActions;

export default function* onCurrentIndexChange(action) {
    // yield put(LightboxActions.setFiles(newFiles));
    const lightboxFiles = yield select(state => state.Lightbox.files);
    const newAction = {
        ...action,
        files: lightboxFiles,
    };

    // to handle lazy loading + processing + setFiles to lightbox
    const newFiles = yield fileManagerChangeIndex(newAction, true);
    const {lightboxType} = action;

    // extra logic to set files to transaction / contacts redux state
    switch (lightboxType) {
        case LightboxType.TRANSACTION:
            yield put(setTransactionFiles(newFiles));
            break;
        case LightboxType.CONTACT:
            yield put(setContactFiles(newFiles));
            break;
        default:
            break;
    }

    return null;
}
